/* kp-app.js — Kit-pro product template interactions
   Vanilla JS, no dependencies. Terminal typing animation + scroll reveals. */
(function(){
  'use strict';

  function ready(fn){
    if(document.readyState!=='loading') fn();
    else document.addEventListener('DOMContentLoaded',fn);
  }

  // Scroll reveal via IntersectionObserver
  function initReveal(){
    var els=document.querySelectorAll('.kp-reveal');
    if(!els.length||!('IntersectionObserver' in window)){
      els.forEach(function(el){el.classList.add('is-in')});
      return;
    }
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    },{threshold:.12,rootMargin:'0px 0px -60px 0px'});
    els.forEach(function(el){io.observe(el)});
  }

  // Terminal typing animation
  function initTerminal(){
    var terms=document.querySelectorAll('.kp-terminal[data-animate="true"]');
    terms.forEach(function(term){
      var lines=term.querySelectorAll('.kp-terminal__line');
      if(!lines.length) return;
      // Hide all, reveal progressively
      lines.forEach(function(l){l.style.opacity='0';l.style.transform='translateY(4px)';l.style.transition='opacity .25s, transform .25s'});
      var start=function(){
        var delay=0;
        lines.forEach(function(l,i){
          setTimeout(function(){
            l.style.opacity='1';
            l.style.transform='translateY(0)';
          },delay);
          // First line (prompt) faster, OK lines slower for drama
          var txt=(l.textContent||'').trim();
          delay+= l.classList.contains('kp-blank') ? 120 : (txt.length>40?450:280);
        });
      };
      // Trigger when terminal enters viewport
      if('IntersectionObserver' in window){
        var io=new IntersectionObserver(function(entries){
          entries.forEach(function(e){
            if(e.isIntersecting){start();io.unobserve(e.target)}
          });
        },{threshold:.35});
        io.observe(term);
      }else{
        start();
      }
    });
  }

  ready(function(){
    initReveal();
    initTerminal();
  });
})();
